import React, { useState, useEffect, useRef } from "react";
import { Autocomplete } from "@react-google-maps/api";
import { useTranslation } from "react-i18next";

const InputAutocompleteAddress = ({
  label,
  value,
  onChange,
  isEditing,
  customStyle,
  errorMessage,
}) => {
  const { t } = useTranslation();
  const [fullAddress, setFullAddress] = useState(value);
  const autocompleteRef = useRef(null);

  useEffect(() => {
    setFullAddress(value);
  }, [value]);

  const handlePlaceChanged = () => {
    const place = autocompleteRef.current?.getPlace();
    if (place && place.formatted_address) {
      const newFullAddress = place.formatted_address;
      setFullAddress(newFullAddress);
      onChange(newFullAddress);
    }
  };

  return (
    <div className="input-field" style={customStyle}>
      <label>{label}</label>
      {isEditing ? (
        <Autocomplete
          onLoad={(autocomplete) => {
            autocompleteRef.current = autocomplete;
          }}
          onPlaceChanged={handlePlaceChanged}
          apiKey={process.env.REACT_APP_GOOGLE_PLACE_API}
          options={{ types: ["address"] }}
          className="google-autocomplete"
        >
          <div style={{ width: "100%" }}>
            <input
              placeholder={t("LOCATION")}
              value={fullAddress}
              onChange={(e) => {
                setFullAddress(e.target.value);
                onChange(e.target.value);
              }}
              style={{ width: "100%" }}
            />
          </div>
        </Autocomplete>
      ) : (
        <div className="display-value">{value}</div>
      )}
      {errorMessage && <div className="error-message">{errorMessage}</div>}
    </div>
  );
};

export default InputAutocompleteAddress;
